import {createRoot, hydrateRoot} from 'react-dom/client';
import KnowledgeHub from '../pages/KnowledgeHub/KnowledgeHub'
import "../index.css";
import "../pages/KnowledgeHub/KnowledgeHub.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<KnowledgeHub {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <KnowledgeHub {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).KnowledgeHubVC = {mount, hydrate, unmount}